export default "__VITE_ASSET__DTx7Tkg7__"